import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { AcceptedOffersTableDefinitionZod } from '../tables';

type Arguments = {
    filter?: string;
    offerId: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetAcceptedOffersById = AcceptedOffersTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetAcceptedOffersById = z.infer<
    typeof schemaLoanRequestResolver_GetAcceptedOffersById
>;

export type LoanRequestResolver_GetAcceptedOffersById = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetAcceptedOffersById
>;
